import { TabConexiones } from "./TabConexiones";
import { TabDocumentacion } from "./TabDocumentacion";
import { TabDocumentacionLegal } from "./TabDocumentacionLegal";
import { TabEnvios } from "./TabEnvios";
import { TabEstado } from "./TabEstado";
import { TabIndicacion } from "./TabIndicacion";
import { TabPaciente } from "./TabPaciente";
import { TabProfesional } from "./TabProfesional";
import { TabRemitosBNP } from "./TabRemitosBNP";
import { TabUbicaciones } from "./TabUbicaciones";

export const tabs = [
    {
        id: 1,
        name: 'Paciente',
        component: <TabPaciente />,
    },
    {
        id: 2,
        name: 'Ubicaciones',
        component: <TabUbicaciones />,
    },
    {
        id: 3,
        name: 'Doc. Legal',
        component: <TabDocumentacionLegal />,
    },
    {
        id: 4,
        name: 'Profesional',
        component: <TabProfesional />,
    },
    {
        id: 5,
        name: 'Envíos',
        component: <TabEnvios />,
    },
    {
        id: 6,
        name: 'Conexiones',
        component: <TabConexiones />,
    },
    {
        id: 7,
        name: 'Estado',
        component: <TabEstado />,
    },
    {
        id: 8,
        name: 'Indicación',
        component: <TabIndicacion />,
    },
    {
        id: 9,
        name: 'Documentación',
        component: <TabDocumentacion />,
    },
    {
        id: 10,
        name: 'BNP',
        component: <TabRemitosBNP />,
    }
];